webpackJsonp([249842937396398],{

/***/ 1599:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"slug":"/it/tutoring/","langKey":"it"}}

/***/ })

});


// WEBPACK FOOTER //
// path---it-tutoring-474c307932a72e1e95ff.js